import React, { useEffect } from "react";
import { Check } from "lucide-react";
import { useTranslation } from "react-i18next";
import { preloadFaceLandmarker } from "../liveness/FaceLandmarkerClient";
import { FaceVideoGuideAnimation } from "../components/StepGuideAnimations";
import { KycStep } from "../components/KycStep";
import { StepFooter } from "../components/StepFooter";

export function LivenessPreparationStep({ onBack, onContinue }) {
  const { t } = useTranslation();
  const tips = ["center", "lighting", "accessories"];

  useEffect(() => {
    preloadFaceLandmarker().catch((error) => {
      // 预加载失败不阻断引导页；活体页会再次初始化并提供重试。
      // 保留原始技术错误，避免最终的通用提示掩盖真正原因。
      console.warn("[活体检测] MediaPipe 人脸模型预加载结果：失败", {
        原始错误名称: error?.name || "Error",
        原始错误信息: error?.message || String(error),
      });
    });
  }, []);

  return (
    <KycStep
      labelledBy="kyc-liveness-preparation-title"
      className="kyc-preparation-step liveness-preparation-step"
    >
      <div className="text-center">
        <FaceVideoGuideAnimation />
        <h1
          id="kyc-liveness-preparation-title"
          className="mt-6 text-[1.35rem] font-semibold leading-tight tracking-[-0.035em] text-slate-950 sm:text-[2rem]"
        >
          {t("kyc.livenessPreparation.title")}
        </h1>
        <p className="mx-auto mt-3 max-w-md text-sm leading-6 text-slate-600">
          {t("kyc.livenessPreparation.description")}
        </p>
      </div>

      <GuideTips tips={tips} namespace="kyc.livenessPreparation" t={t} />

      <StepFooter
        onBack={onBack}
        onContinue={onContinue}
        continueLabel={t("kyc.livenessPreparation.continue")}
        compact
      />
    </KycStep>
  );
}

function GuideTips({ tips, namespace, t }) {
  return (
    <ul className="mx-auto mt-6 max-w-md space-y-2.5">
      {tips.map((tip) => (
        <li
          key={tip}
          className="flex items-center gap-3 text-left text-sm leading-6 text-slate-600"
        >
          <span className="flex size-6 shrink-0 items-center justify-center rounded-full bg-teal-50 text-teal-700 ring-1 ring-teal-100">
            <Check className="size-3.5" strokeWidth={2.5} aria-hidden="true" />
          </span>
          {t(`${namespace}.${tip}`)}
        </li>
      ))}
    </ul>
  );
}
